<template>
  <div>
    <h3 class="text-gray-400 mb-4">Tag toevoegen aan {{ contact.name }}</h3>
    <div>
      <label>
        <span class="block mb-1">Zoek een tag of maak nieuwe</span>
        <input
          type="text"
          v-model="input"
          class="form-input w-full"
          placeholder="Tag"
          autofocus
          maxlength="20"
        />
      </label>
      <div class="mt-3">
        <button
          v-if="showCreateTag"
          class="block py-1 px-3 hover:bg-blue-100 hover:text-blue-600 rounded w-full flex justify-between items-center group"
          @click="addTag(input)"
        >
          <span>{{ input }}</span>
          <span class="text-white group-hover:text-blue-400">Maak tag</span>
        </button>
        <button
          class="block py-1 px-3 hover:bg-blue-100 hover:text-blue-600 rounded w-full flex justify-between items-center group"
          v-for="tag in tags"
          :key="tag"
          @click="addTag(tag)"
        >
          <span>{{ tag }}</span>
          <span class="text-white group-hover:text-blue-400">Kies tag</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/api";

export default {
  inject: ["close"],

  props: {
    action: {
      type: String,
      required: true
    },
    used: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      input: ""
    };
  },

  watch: {
    input() {
      this.input = this.input.replace(" ", "-");
    }
  },

  computed: {
    contact() {
      return this.$store.state.contact;
    },

    showCreateTag() {
      let input = this.input.toLowerCase();

      if (input) {
        return !this.tags.map(tag => tag.toLowerCase()).includes(input);
      } else {
        return false;
      }
    },

    tags() {
      let input = this.input.toLowerCase();
      let used = this.used.map(tag => tag.name.toLowerCase());

      return this.$store.state.settings.tags
        .filter(tag => tag.toLowerCase().includes(input))
        .filter(tag => !used.includes(tag.toLowerCase()))
        .slice(0, 10);
    }
  },

  methods: {
    addTag(tag) {
      if (!tag) return;

      post(`/contacts/${this.contact.id}/tags`, { tag }).then(response => {
        this.$store.dispatch("loadSettings");
        this.$store.commit("SET_CONTACT", response.data);
      });

      this.close();
    }
  }
};
</script>
